<ng-container *transloco="let t;">
    <div class="container d-flex justify-content-center align-items-center">
        <div class="w-100 py-4" style="max-width: 80rem;">
            <breadcrumb [items]='[
                { label: t("header.frontpage"), route: "/schemas"},
                { label: t("schema.tableheader.schema"), route: "/"}
             ]'></breadcrumb>
            <ng-container *ngIf="!isLoading(); else isLoadingState">
                <ng-container *ngIf="!hasSchemaError()">
                    <app-formio-schema *ngIf="formioData" [formioData]="formioData" [schemaInfo]="schemaInfo">
                    </app-formio-schema>
                </ng-container>
                <ng-container *ngIf="hasSchemaError()">
                    <p class="fs-5">{{ t("schema.schemanotfound")}}</p>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>

<div class="modal modal-xl fade" id="assistedDialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="assistedAccessDialogLabel">
    <assisted-access-dialog [schemaId]="schemaId"></assisted-access-dialog>
</div>

<ng-template #isLoadingState>
    <overlay-loading-spinner-border [show]="isLoading" />
</ng-template>